import { useEffect, useState } from "react";
import cx from "ui/cx";
import styles from "ui/forms/Input/Input.module.scss";
import TextareaMaxCharWrapper from "ui/text/TextareaMaxCharWrapper";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputState?: "error" | "success";
  validate?: () => string | null;
}

export default function Textarea({ maxLength, validate, inputState = "success", onBlur, ...props }: TextareaProps) {
  const [error, setError] = useState<string | undefined>(undefined);
  const [touched, setTouched] = useState(false);
  const classNames = cx({
    styles,
    wrapper: true,
    [inputState]: true,
    error: error !== undefined ? error : false,
  });

  const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>): void => {
    setTouched(true);

    if (typeof validate === "function") {
      const msg = validate() ?? "";
      setError(msg);

      if (!msg) {
        setTouched(false);
      }
    }

    onBlur && onBlur(e);
  };

  const charLength = String(props.value || "").length;
  const inputEl = maxLength ? (
    <TextareaMaxCharWrapper maxLength={maxLength} charLength={charLength}>
      <textarea className={classNames} onBlur={handleBlur} {...props} maxLength={maxLength} />
    </TextareaMaxCharWrapper>
  ) : (
    <textarea className={classNames} onBlur={handleBlur} {...props} maxLength={maxLength} />
  );

  if (error && touched) {
    return (
      <div className={styles.validationWrapper}>
        {inputEl}
        <span className={styles.validationError}>{error}</span>
      </div>
    );
  }

  return inputEl;
}

export function ReturnCommitTextarea({ value: inputValue, ...props }: TextareaProps) {
  const [value, setValue] = useState(inputValue);
  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);
  return <Textarea {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
}
